import { render, staticRenderFns } from "./CodeBoxButtonForCodeEditor.vue?vue&type=template&id=795db3ec&"
import script from "./CodeBoxButtonForCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./CodeBoxButtonForCodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CodeBoxButtonForCodeEditor.vue?vue&type=style&index=0&id=795db3ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports